"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by Vanush Voskanyan 27/4/2018
 */
var core_1 = require("@angular/core");
var idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
var condition_text_generator_service_1 = require("../condition-text-generator-service");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var Observable_1 = require("rxjs/Observable");
var style_converter_1 = require("../../converter/style-converter");
var material_1 = require("@angular/material");
var row_formatting_model_1 = require("../row-formatting/model/row-formatting-model");
var idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
var branchindex_measurepathholder_ids_creator_1 = require("../branchindex-measurepathholder-ids-creator");
var SisRowFormattingRulesListingComponent = /** @class */ (function () {
    function SisRowFormattingRulesListingComponent(currentLanguageProvider, conditionTextGeneratorService, branchIndexMeasurePathHolderIdsCreator) {
        var _this = this;
        this.currentLanguageProvider = currentLanguageProvider;
        this.conditionTextGeneratorService = conditionTextGeneratorService;
        this.branchIndexMeasurePathHolderIdsCreator = branchIndexMeasurePathHolderIdsCreator;
        this.subscriptions = [];
        var currentLanguageSubscription = this.currentLanguageProvider.getCurrentLanguage()
            .subscribe(function (language) {
            _this._currentLanguage = language;
        });
        this.subscriptions.push(currentLanguageSubscription);
        this.selectedRowFormattingModel = new row_formatting_model_1.RowFormattingModel();
        this._branchIndexMeasurePathHolderIdPairs = Observable_1.Observable.of(new Map());
        this.conditionsChange = new core_1.EventEmitter();
    }
    SisRowFormattingRulesListingComponent.prototype.ngOnChanges = function (changes) {
        this.selectedRowFormattingModel.formattingConditionIndex = undefined;
        if (this.selectedElementFormattingRule) {
            this.selectedRowFormattingModel.rowFormattingRule = this.selectedElementFormattingRule;
        }
        if (this.selectedElementAlias) {
            this.selectedRowFormattingModel.caption = this.selectedElementAlias.getValue(this._currentLanguage.getId());
        }
        this.selectedRowFormattingModel.languageId = this._currentLanguage.getId();
        this.selectedRowFormattingModel.dataSetId = this.dataSetId;
        if (changes && changes['columnRootDto']) {
            this.branchIndexMeasurePathHolderIdsCreator.identifyDatasetId(this.dataSetId);
            this._branchIndexMeasurePathHolderIdPairs =
                this.branchIndexMeasurePathHolderIdsCreator.getBranchIndexWithFirstLevelColumnMeasurePathHolderIds(this.columnRootDto);
        }
    };
    SisRowFormattingRulesListingComponent.prototype.ngOnInit = function () {
        this.conditionTextGeneratorService.initializeMeasurePaths(this.dataSetId);
    };
    SisRowFormattingRulesListingComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    /**
     * Check whether there are measures in columns first level.
     * If there aren't Conditional formatting button will be disabled
     */
    SisRowFormattingRulesListingComponent.prototype.isFirstLevelMeasurePresentInReport = function () {
        return this._branchIndexMeasurePathHolderIdPairs.map(function (value) {
            return Array.from(value).length > 0;
        });
    };
    SisRowFormattingRulesListingComponent.prototype.getFormattingConditionInfo = function (condition) {
        if (condition instanceof idm_report_export_service_client_js_1.MeasureToMeasureComparisonFormattingConditionDto) {
            return this.conditionTextGeneratorService
                .getMeasureToMeasureComparisonFormattingConditionInfo(condition, this.getPathHolderId(condition.getMeasureElement1BranchIndex()), this.getPathHolderId(condition.getMeasureElement2BranchIndex()));
        }
        else if (condition instanceof idm_report_export_service_client_js_1.BetweenFormattingConditionDto) {
            return this.conditionTextGeneratorService.getBetweenFormattingConditionInfo(condition, this.getPathHolderId(condition['measureElementBranchIndex']));
        }
        else if (condition instanceof idm_report_export_service_client_js_1.ConstantFormattingConditionDto) {
            return this.conditionTextGeneratorService.getConstantFormattingConditionInfo(condition, this.getPathHolderId(condition['measureElementBranchIndex']));
        }
        else {
            throw new Error('Invalid type of formatting condition');
        }
    };
    SisRowFormattingRulesListingComponent.prototype.getPathHolderId = function (branchIndex) {
        return this._branchIndexMeasurePathHolderIdPairs.map(function (mapOfBranchIndexAndPathHolderIds) {
            return mapOfBranchIndexAndPathHolderIds.get(branchIndex);
        });
    };
    SisRowFormattingRulesListingComponent.prototype.getFormattingConditions = function () {
        if (this.selectedElementFormattingRule) {
            return this.selectedElementFormattingRule.getFormattingConditions();
        }
        else {
            return [];
        }
    };
    SisRowFormattingRulesListingComponent.prototype.getStyle = function (condition) {
        var chipStyle = condition.getStyle();
        if (chipStyle) {
            var chipStyleWithBackgroundColor = Object.create(chipStyle);
            return style_converter_1.StyleConverter.covert(chipStyleWithBackgroundColor);
        }
        return {};
    };
    SisRowFormattingRulesListingComponent.prototype.deleteCondition = function (id) {
        this.selectedElementFormattingRule.getFormattingConditions().splice(id, 1);
        this.conditionsChange.emit();
    };
    SisRowFormattingRulesListingComponent.prototype.newCondition = function () {
        this.selectedRowFormattingModel = new row_formatting_model_1.RowFormattingModel(this.selectedRowFormattingModel);
        this.selectedRowFormattingModel.formattingConditionIndex = null;
        this.drawer.toggle(!this.drawer.opened);
    };
    SisRowFormattingRulesListingComponent.prototype.editCondition = function (id) {
        this.selectedRowFormattingModel = new row_formatting_model_1.RowFormattingModel(this.selectedRowFormattingModel);
        this.selectedRowFormattingModel.formattingConditionIndex = id;
        this.drawer.toggle(!this.drawer.opened);
    };
    Object.defineProperty(SisRowFormattingRulesListingComponent.prototype, "showFormattingCondition", {
        get: function () {
            return this.selectedRowFormattingModel.formattingConditionIndex === null || this.selectedRowFormattingModel.formattingConditionIndex !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisRowFormattingRulesListingComponent.prototype, "branchIndexMeasurePathHolderIdPairs", {
        get: function () {
            return this._branchIndexMeasurePathHolderIdPairs;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_crosscutting_concepts_frontend_1.MultilingualString)
    ], SisRowFormattingRulesListingComponent.prototype, "selectedElementAlias", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_report_export_service_client_js_1.RowFormattingRule)
    ], SisRowFormattingRulesListingComponent.prototype, "selectedElementFormattingRule", void 0);
    __decorate([
        core_1.ViewChild('drawer'),
        __metadata("design:type", material_1.MatDrawer)
    ], SisRowFormattingRulesListingComponent.prototype, "drawer", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], SisRowFormattingRulesListingComponent.prototype, "dataSetId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_reporting_service_client_js_1.ColumnRootDto)
    ], SisRowFormattingRulesListingComponent.prototype, "columnRootDto", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], SisRowFormattingRulesListingComponent.prototype, "conditionsChange", void 0);
    SisRowFormattingRulesListingComponent = __decorate([
        core_1.Component({
            
            selector: 'sis-row-formatting-rules-listing',
            template: require('./sis-row-formatting-rules-listing-component.html'),
            styles: [require('./sis-row-formatting-rules-listing-component.css')]
        }),
        __metadata("design:paramtypes", [idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            condition_text_generator_service_1.ConditionTextGeneratorService,
            branchindex_measurepathholder_ids_creator_1.BranchIndexMeasurePathHolderIdsCreator])
    ], SisRowFormattingRulesListingComponent);
    return SisRowFormattingRulesListingComponent;
}());
exports.SisRowFormattingRulesListingComponent = SisRowFormattingRulesListingComponent;
//# sourceMappingURL=sis-row-formatting-rules-listing-component.js.map